import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN } from '@env';

let initialized = false;

export function initializeMixpanel(): void {
  if (initialized) return;

  const token = MIXPANEL_TOKEN;
  if (!token) {
    console.warn('Mixpanel token not found');
    return;
  }

  mixpanel.init(token, {
    track_pageview: true,
    persistence: 'localStorage',
  });

  initialized = true;
}

export function mixpanelIdentify(userId: string): void {
  if (!initialized) return;
  mixpanel.identify(userId);
}

export function mixpanelPeopleSet(properties: Record<string, any>): void {
  if (!initialized) return;
  mixpanel.people.set(properties);
}

export function mixpanelTrack(eventName: string, properties?: Record<string, any>): void {
  if (!initialized) return;
  mixpanel.track(eventName, properties);
}

export function mixpanelReset(): void {
  if (!initialized) return;
  mixpanel.reset();
}
